export function toNewFixed(n) {
    // // n为期望保留的位数，超过限定，报错！
    // if (n > 20 || n < 0) {
    //     throw new RangeError(`toFixed() digits argument must be between 0 and 20`)
    // }
    // // 获取数字
    // const number = this
    // // 如果是NaN,或者数字过大，直接返回'NaN'或者类似'1e+21'的科学计数法字符串
    // if (isNaN(number) || number >= Math.pow(10, 21)) {
    //     return number.toString()
    // }
    // // 默认保留整数
    // if (typeof (n) == `undefined` || n == 0) {
    //     return (Math.round(number)).toString()
    // }

    // // 先获取字符串
    // let result = number.toString()
    // // 获取小数部分
    // const arr = result.split(`.`)

    // // 整数的情况，直接在后面加上对应个数的0即可
    // if (arr.length < 2) {
    //     result += `.`
    //     for (let i = 0; i < n; i += 1) {
    //         result += `0`
    //     }
    //     return result
    // }

    // // 整数和小数
    // const integer = arr[0]
    // const decimal = arr[1]
    // // 如果已经符合要求位数，直接返回
    // if (decimal.length == n) {
    //     return result
    // }
    // // 如果小于指定的位数，补上
    // if (decimal.length < n) {
    //     for (let i = 0; i < n - decimal.length; i += 1) {
    //         result += `0`
    //     }
    //     return result
    // }
    // // 如果到这里还没结束，说明原有小数位多于指定的n位
    // // 先直接截取对应的位数
    // result = integer + `.` + decimal.substr(0, n)
    // // 获取后面的一位
    // let last = decimal.substr(n, 1)
    // if (/^\d(9){5,}[89]$/.test(decimal.substr(n))) {
    //     last += last + 1
    // }
    // // 大于等于5统一进一位
    // if (parseInt(last, 10) >= 5) {
    //     // 转换倍数，转换为整数后，再进行四舍五入
    //     const x = Math.pow(10, n)
    //     // 进一位后，转化还原为小数
    //     result = (Math.round((parseFloat(result) * x)) + 1) / x
    //     // 再确认一遍
    //     result = result.toFixed(n)
    // }

    // return result
    let value = this
    var plusminus = value < 0 ? -1 : 1
    let numMultiple = Math.pow(10, n)
    let result = (Math.round(value * plusminus * numMultiple) / numMultiple) * plusminus
    return result
}

function isInteger(obj) {
    return Math.floor(obj) === obj
}

// 用于返回整数和倍数
function toInteger(floatNum) {
    // 声明一个对象用来保存倍数和整数
    var ret = { times: 1, num: 0 }
    // 第一种情况：是整数
    if (!floatNum) {
        return ret
    }
    if (isInteger(floatNum)) {
        // 把整数给 ret中的   num
        ret.num = floatNum
        return ret //  最后返回 ret
    }

    // 第二种情况-不是整数，
    var strfi = floatNum + `` // 转为字符串  "0.1"
    var dotPos = strfi.indexOf(`.`) // 查询小数点
    var len = strfi.substr(dotPos + 1).length //  获取小数点后的长度
    var times = Math.pow(10, len) // 放大多少倍
    var intNum = Number(floatNum.toString().replace(`.`, ``)) // 返回 转为字符串  截取掉小数点  最后转为数字（整数）
    // 把获取到的倍数和整数存入对象中
    ret.times = times
    ret.num = intNum
    return ret
}

function multiply(a, b) {
    // 获取倍数和整数的对象
    var o1 = toInteger(a)
    var o2 = toInteger(b)
    // 提取整数
    var n1 = o1.num
    var n2 = o2.num
    // 提取倍数
    var t1 = o1.times
    var t2 = o2.times
    var result = null //
    result = (n1 * n2) / (t1 * t2)
    return result
}

export default { isInteger, toInteger, multiply }



// WEBPACK FOOTER //
// ./src/reloadToFixed.js